import { useState, useEffect } from 'react';

// WMO weather code groupings
const RAIN_CODES = new Set([51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82, 95, 96, 99]);
const SNOW_CODES = new Set([71, 73, 75, 77, 85, 86]);
const FOG_CODES = new Set([45, 48]);

export default function useWeather() {
  const [weather, setWeather] = useState({
    rain: false,
    snow: false,
    fog: false,
    wind: false,
  });

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        let lat, lon, city;

        try {
          const geo = await fetch('https://get.geojs.io/v1/ip/geo.json').then(r => r.json());
          lat = geo.latitude;
          lon = geo.longitude;
          city = geo.city;
        } catch {
          const geo = await fetch('http://ip-api.com/json/?fields=lat,lon,city').then(r => r.json());
          lat = geo.lat;
          lon = geo.lon;
          city = geo.city;
        }

        if (cancelled || !lat || !lon) return;

        const data = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current_weather=true`
        ).then(r => r.json());

        if (cancelled) return;

        const code = data?.current_weather?.weathercode;
        const windSpeed = data?.current_weather?.windspeed ?? 0;

        const result = {
          rain: typeof code === 'number' && RAIN_CODES.has(code),
          snow: typeof code === 'number' && SNOW_CODES.has(code),
          fog: typeof code === 'number' && FOG_CODES.has(code),
          wind: windSpeed > 30, // km/h — moderate to strong wind
        };

        console.log(`[Weather] ${city} | code: ${code} | wind: ${windSpeed}km/h | ${Object.entries(result).filter(([,v]) => v).map(([k]) => k).join(', ') || 'clear'}`);

        setWeather(result);
      } catch (err) {
        console.log('[Weather] Error:', err.message);
      }
    }

    check();
    return () => { cancelled = true; };
  }, []);

  return weather;
}
